// src/api/index.js
import axios from "axios";
import router from "../router/index";
import {Message} from "element-ui";
import config from "../global/config.js";
import {lcGetWithAge, ssGet} from "../global/utils";

axios.defaults.timeout = 10000;
// axios.defaults.withCredentials = true;

if (process.env.NODE_ENV === "development") {
    axios.defaults.baseURL = config.BASE_URL;
} else if (process.env.NODE_ENV === "debug") {
    axios.defaults.baseURL = "";
} else if (process.env.NODE_ENV === "production") {
    axios.defaults.baseURL = "";
}

// axios.defaults.headers.post["Content-Type"] =
//   "application/x-www-form-urlencoded;charset=UTF-8";

axios.interceptors.request.use(
    config => {
        let YLJGDM = localStorage.getItem("YLJGDM");
        let params = [];
        if (YLJGDM) {
            params.push(`YLJGDM=${YLJGDM}`);
        }
        let clientId = localStorage.getItem("clientId");
        if (clientId) {
            params.push(`clientId=${clientId}`);
        }
        if (params.length) {
            params = params.join(";");
        }
        config.headers["Authorization"] = params;

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        const responseCode = response.status;
        if (responseCode === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        console.log(error, '55');
        if (!error.response) {
            if (error.message.includes("timeout")) {
                console.log("超时了");
                errMessage("请求超时，请检查网络是否连接正常");
            } else {
                // 可以展示断网组件
                console.log("断网了");
                errMessage("请求失败，请检查网络是否已连接");
            }
        } else {
            return Promise.reject(error);
        }
    }
);

function errMessage(msg) {
    Message.closeAll();
    Message({
        message: msg,
        type: "error",
        // iconClass: "string",
        // customClass: "base_polling_msgBox",
        showClose: true,
        duration: 0
    });
}

function getUrl(url) {
    if (url.indexOf('?') > -1) {
        return `/web/api${config.api_version}` + url + "&token=" + lcGetWithAge("token");
    } else {
        return `/web/api${config.api_version}` + url + "?token=" + lcGetWithAge("token");
    }
}

function getImageUrl(url) {
    url = url + "&token=" + lcGetWithAge("token");
    return axios.defaults.baseURL + url;
}
function getQrImageUrl(url) {
    url = url + "?token=" + lcGetWithAge("token");
    return axios.defaults.baseURL + `/web/api${config.api_version}` + url;
}

function get(url, params = {}, config = {}) {
    url = getUrl(url);
    return new Promise((resolve, reject) => {
        axios.get(url, {params: params, ...config}).then(
            response => {
                if (!response) return;
                let res = response.data;
                if (res.code === 0) {
                    resolve(response.data);
                } else if (res.code === 1005 || res.code === 1004) {
                    router.push({
                        path: "/login"
                    });
                } else if (res.code === 1001) {
                    reject(res);
                    errMessage("服务异常，请检查网络或联系客服");
                    console.log("status code:" + res.code, url);
                } else if (res.code === 1006) {
                    errMessage('没有该权限！')
                } else if (res.code === 1003) {
                    errMessage(res.msg)
                } else {
                    reject(res)
                }
            },
            reject => {
                if (reject.status !== 0) {
                    console.log("error", reject);
                    errMessage("服务异常，请检查网络或联系客服");
                }
            }
        );
    });
}

function post(url, param, config, urlParams = {}) {
    url = getUrl(url);
    return new Promise((resolve, reject) => {
        axios.post(url, param, config).then(
            response => {
                if (!response) return;
                let res = response.data;
                if (res.code === 0) {
                    resolve(response.data);
                } else if (res.code === 1005 || res.code === 1004) {
                    router.push({
                        path: "/login"
                    });
                } else if (res.code === 1001) {
                    reject(res);
                    errMessage(res.msg || "服务异常，请检查网络或联系客服");
                    console.log("status code:" + res.code, url);
                } else if (res.code === 1006) {
                    errMessage('没有该权限！')
                } else if (res.code === 1003) {
                    errMessage(res.msg)
                } else {
                    reject(res);
                }
            },
            reject => {
                if (reject.status !== 0) {
                    console.log("error", reject);
                    errMessage("服务异常，请检查网络或联系客服");
                }
            }
        );
    });
}

function put(url, params) {
    url = getUrl(url);
    return new Promise((resolve, reject) => {
        axios.put(url, params).then(
            response => {
                if (!response) return;
                let res = response.data;
                if (res.code === 0) {
                    resolve(response.data);
                } else if (res.code === 1005) {
                    router.push({
                        path: "/login"
                    });
                } else if (res.code === 1001) {
                    reject(res);
                    errMessage("服务异常，请检查网络或联系客服");
                    console.log("status code:" + res.code, url);
                } else if (res.code === 1006) {
                    errMessage('没有该权限！')
                } else if (res.code === 1003) {
                    errMessage(res.msg)
                } else {
                    reject(res);
                }
            },
            reject => {
                if (reject.status !== 0) {
                    console.log("error", reject);
                    errMessage("服务异常，请检查网络或联系客服");
                }
            }
        )
    })
}

function del(url, params) {
    url = getUrl(url);
    return new Promise((resolve, reject) => {
        axios.delete(url, params).then(
            response => {
                if (!response) return;
                let res = response.data;
                if (res.code === 0) {
                    resolve(response.data);
                } else if (res.code === 1005) {
                    router.push({
                        path: "/login"
                    });
                } else if (res.code === 1001) {
                    reject(res);
                    errMessage("服务异常，请检查网络或联系客服");
                    console.log("status code:" + res.code, url);
                } else if (res.code === 1006) {
                    errMessage('没有该权限！')
                } else if (res.code === 1003) {
                    errMessage(res.msg)
                } else {
                    reject(res);
                }
            },
            reject => {
                if (reject.status !== 0) {
                    console.log("error", reject);
                    errMessage("服务异常，请检查网络或联系客服");
                }
            }
        )
    })
}

function langRequest(url, params) {
    url = getUrl(url);
    return new Promise((resolve, reject) => {
        axios({
            url: url,
            type: params.type,
            timeout: params.time,
            params: params.data,
        }).then(
            response => {
                if (!response) return;
                let res = response.data;
                if (res.code === 0) {
                    resolve(response.data);
                } else if (res.code === 1005) {
                    router.push({
                        path: "/login"
                    });
                } else if (res.code === 1001) {
                    reject(res);
                    errMessage("服务异常，请检查网络或联系客服");
                    console.log("status code:" + res.code, url);
                } else if (res.code === 1006) {
                    errMessage('没有该权限！')
                } else if (res.code === 1003) {
                    errMessage(res.msg)
                } else {
                    reject(res);
                }
            },
            reject => {
                if (reject.status !== 0) {
                    console.log("error", reject);
                    errMessage("服务异常，请检查网络或联系客服");
                }
            }
        )
    })

}

export {axios, get, post, put, del, getImageUrl,getUrl, getQrImageUrl, langRequest};
